import 'src/styles/pages/home/rowTableRankFishSkeleton.scss'

const RowTableRankFishSkeleton = () => (
    <tr className="row-table-rank-fish-skeleton">
        <td><div className="skeleton-box skeleton-1"></div></td>
        <td><div className="skeleton-box skeleton-2"></div></td>
        <td><div className="skeleton-box skeleton-3"></div></td>
        <td><div className="skeleton-box skeleton-4"></div></td>
        <td><div className="skeleton-box skeleton-5"></div></td>
        <td><div className="skeleton-box skeleton-6"></div></td>
    </tr>
)

export default RowTableRankFishSkeleton